import { CANVAS_MIN_ZOOM } from '@blocksuite/store';

export const ZOOM_MIN = CANVAS_MIN_ZOOM;
export const ZOOM_MAX = 4;
export const ZOOM_INITIAL = 1;
/** A signed step count, not an additive percentage-point delta. */
export const ZOOM_STEP = 1;
export const ZOOM_FACTOR = 1.2;
const MAX_WHEEL_DELTA = 10;
const PINCH_GAIN = 0.6;

export function zoomBySteps(
  zoom: number,
  steps: number,
  min = ZOOM_MIN,
  max = ZOOM_MAX
) {
  return Math.min(max, Math.max(min, zoom * Math.pow(ZOOM_FACTOR, steps)));
}

/** Relative zoom at every scale, including the final steps down to 2%. */
export function zoomFromWheel(
  zoom: number,
  deltaY: number,
  options: {
    deltaMode?: number;
    ctrlKey?: boolean;
    viewportHeight?: number;
  } = {}
) {
  const unit =
    options.deltaMode === 1
      ? 16
      : options.deltaMode === 2
        ? Math.max(1, options.viewportHeight ?? 1)
        : 1;
  const delta = deltaY * unit;
  const steps =
    ((-Math.sign(delta) * Math.min(Math.abs(delta), MAX_WHEEL_DELTA)) /
      MAX_WHEEL_DELTA) *
    (options.ctrlKey ? PINCH_GAIN : 1);
  return zoomBySteps(zoom, steps);
}
